import { type Meta } from '@air/analytics';

const META: Meta = {
  description: 'User initialized the plugin',
  name: 'plugin_initialization',
  params: [],
};

export default META;
